import React from 'react';
import PasswordSetupForm from '@/components/PasswordSetupForm';

/**
 * Landing page for the forgot-password flow. Reads a `?token=` query param and
 * calls POST /api/auth/reset-password. On success routes back to /login with
 * a `?reset=true` flag.
 */
export default function ResetPasswordPage() {
  return (
    <PasswordSetupForm
      title="Reset your password"
      subtitle="Choose a new password for your SHINE Ops Hub account."
      endpoint="/api/auth/reset-password"
      successMessage="Password updated — you can now sign in."
      redirectQuery="reset=true"
      submitLabel="Update password"
      testIdPrefix="reset-password"
    />
  );
}
